import BoardGameIcon from "assets/icons/BoardGame";
import CockFightingIcon from "assets/icons/CookFighting";
import ESportIcon from "assets/icons/Esport.svg";
import LiveCasinoIcon from "assets/icons/Live.svg";
import SlotGameIcon from "assets/icons/Slot.svg";
import SportIcon from "assets/icons/Sport.svg";
import { CategoryGameType } from "types/game";

import { PATH } from "./path";

export const CATEGORY_GAME: CategoryGameType[] = [
  {
    id: "LC",
    name: "Live Casino",
    icon: LiveCasinoIcon,
    path: PATH.gameLivePage,
  },
  {
    id: "SL",
    name: "Slots",
    icon: SlotGameIcon,
    path: PATH.gameSlotsPage,
  },
  {
    id: "ES",
    name: "E-Sport",
    icon: ESportIcon,
    path: PATH.gameESportPage,
  },
  {
    id: "SB",
    name: "Sport",
    icon: SportIcon,
    path: PATH.gameSportPage,
  },
  {
    id: "BG",
    name: "Board Game",
    icon: <BoardGameIcon />,
    path: PATH.gameBoardGamePage,
  },
  {
    id: "CF",
    name: "Cock Fighting",
    icon: <CockFightingIcon />,
    path: PATH.gameCockFighting,
  },
];
